import React from "react";
import Logo from "../../images/logo.png";

function Consumer_header() {
    return (
        <header className="w-full bg-background border-b border-border px-4 py-3 flex items-center">
            {!window.opener ? (
                <a href="/" aria-label="Go to home">
                    <img src={Logo} alt="RxHacker" className="h-8 w-auto" />
                </a>
            ) : (
                <img src={Logo} alt="RxHacker" className="h-8 w-auto" />
            )}
        </header>
    );
}

export default Consumer_header;
